<app-social-content-tiles-list
  [analyticsNodes]="sortedNodes()"
  [briefingTimeline]="true"
  [creatorBriefingMode]="creatorBriefingMode"
  [loading]="loading()"
  [resetToPlanned]="resetToPlanned()"
  (tileClicked)="onTileClick($event)"
/>
